<div class="content-info">
  <div class="content-title">
    <h3 class="title">Purchase Orders</h3>
    <div class="title-actions">
      <label class="zf-search" title="Search by PO number">
        <i class="bi bi-search"></i>
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search PO number" />
      </label>
      <button class="btn btnprimary text-nowrap" [routerLink]="['/po/create-po']">
        <i class="bi bi-plus-lg"></i>Create PO
      </button>
    </div>
  </div>

  <!-- Tab navigation: active / received / expired. Counts follow the filters. -->
  <div class="zf-card-head d-print-none">
    <div class="zf-tabs">
      <button type="button" class="zf-tab" [class.active]="activeTab === 'active'" (click)="switchTab('active')">
        Active PO<span class="zf-tab-count">{{ activePoCount }}</span>
      </button>
      <button type="button" class="zf-tab" [class.active]="activeTab === 'expiredWithGrn'"
        (click)="switchTab('expiredWithGrn')">
        PO with GRN<span class="zf-tab-count">{{ expiredPoCount }}</span>
      </button>
      <button type="button" class="zf-tab" [class.active]="activeTab === 'expiredWithoutGrn'"
        (click)="switchTab('expiredWithoutGrn')">
        Expired PO<span class="zf-tab-count">{{ expiredWithoutGrnPoCount }}</span>
      </button>
    </div>
    <div class="zf-tabs-right ms-auto">
      <span>{{ totalPurchaseOrders }} orders in this view</span>
    </div>
  </div>

  <!-- List filters: vendor / order-date range / status (server-side) -->
  <div class="zf-toolbar d-print-none">
    <div class="zf-toolbar-field" style="min-width: 240px">
      <label>Vendor</label>
      <app-search-select [items]="vendors" bindLabel="name" bindValue="id" entity="vendor"
        [(ngModel)]="filters.vendorId" placeholder="All vendors" (change)="onFilterChange()"
        (clear)="onFilterChange()"></app-search-select>
    </div>
    <div class="zf-toolbar-field">
      <label>Order date from</label>
      <input type="date" class="form-control" [(ngModel)]="filters.fromDate" [max]="filters.toDate || null"
        (change)="onFilterChange()" />
    </div>
    <div class="zf-toolbar-field">
      <label>Order date to</label>
      <input type="date" class="form-control" [(ngModel)]="filters.toDate" [min]="filters.fromDate || null"
        (change)="onFilterChange()" />
    </div>
    <div class="zf-toolbar-field" style="min-width: 130px">
      <label>Status</label>
      <select class="form-select" [(ngModel)]="filters.status" (change)="onFilterChange()">
        <option value="">All</option>
        @for (s of statusOptions; track s) {
        <option [value]="s">{{ s }}</option>
        }
      </select>
    </div>
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearFilters()"
      [disabled]="!hasActiveFilters()">
      <i class="bi bi-x-circle"></i>Clear
    </button>
  </div>

  <div class="common-table">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>PO Number</th>
            <th>Vendor</th>
            <th>Order Date</th>
            <th>Delivery Date</th>
            <th>Expiry Date</th>
            <th class="zf-num">Total Items</th>
            <th class="zf-num">Total Units</th>
            <th class="zf-num">Amount (INR)</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @if(purchaseOrdersLoading) {
          <tr>
            <td colspan="10" class="text-center">Loading purchase orders…</td>
          </tr>
          } @else { @if(!purchaseOrders.length) {
          <tr>
            <td colspan="10">
              <div class="zf-empty">
                <strong>No purchase orders match this view</strong>
                <span>Try another tab, clear the filters or change the search.</span>
              </div>
            </td>
          </tr>
          } @else { @for(po of purchaseOrders; track po.id) {
          <tr>
            <td class="zf-key">
              <a [routerLink]="['/po/edit-po', po.id]" [queryParams]="{ view: true }">{{ po.poNumber }}</a>
            </td>
            <td>{{ po.vendor?.name }}</td>
            <td class="zf-mono">{{ po.orderDate | date : "dd-MM-yy HH:mm" }}</td>
            <td class="zf-mono zf-dim">{{ po.deliveryDate ? (po.deliveryDate | date : "dd-MM-yy") : "-" }}</td>
            <td class="zf-mono zf-dim">{{ po.expiryDate ? (po.expiryDate | date : "dd-MM-yy") : "-" }}</td>
            <td class="zf-num">{{ po.totalItems || 0 }}</td>
            <td class="zf-num zf-dim">{{ po.totalUnits || 0 }}</td>
            <td class="zf-num zf-strong">{{ po.totalAmount | number : '1.2-2' }}</td>
            <td>
              <span class="zf-status" [ngClass]="{
                  warn: po.status === 'DRAFT',
                  ok: po.status === 'POSTED',
                  danger: po.status === 'CANCELLED'
                }">{{ po.status }}</span>
            </td>
            <td>
              <div class="dropdown d-flex justify-content-center">
                <button class="btn zf-row-menu dropdown-toggle" type="button" id="dropdownMenuButton-{{ po.id }}"
                  data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false" title="Actions">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>

                <ul class="dropdown-menu dropdown-menu-end" [attr.aria-labelledby]="'dropdownMenuButton-' + po.id">
                  <li>
                    <a class="dropdown-item" [routerLink]="['/po/edit-po', po.id]" [queryParams]="{ view: true }">
                      <i class="bi bi-eye"></i> View details
                    </a>
                  </li>
                  @if(po.status === 'DRAFT') {
                  <li>
                    <a class="dropdown-item" [routerLink]="['/po/edit-po', po.id]">
                      <i class="bi bi-pencil-square"></i> Edit PO
                    </a>
                  </li>
                  }
                  <li>
                    <a class="dropdown-item" (click)="downloadPo(po.id)">
                      <i class="bi bi-file-earmark-pdf"></i> Download PDF
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" (click)="openConfirmEmailModal(po.id)">
                      <i class="bi bi-envelope-paper"></i> Send email
                    </a>
                  </li>
                  <!-- Recall PO (Admin only) — only for expired POs without a GRN -->
                  @if(authService.isAdmin() && po.status === 'POSTED' && activeTab === 'expiredWithoutGrn') {
                  <li>
                    <a class="dropdown-item" (click)="openRecallModal(po)">
                      <i class="bi bi-arrow-counterclockwise"></i> Recall PO
                    </a>
                  </li>
                  }
                </ul>
              </div>
            </td>
          </tr>
          } } }
        </tbody>
      </table>
    </div>

    <div class="table-pagination">
      <div class="pagination-count">
        <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
        <span>entries per page</span>
      </div>
      <ul class="pagination">
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <a class="page-link">&lsaquo;</a>
        </li>
        <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
          <a class="page-link">1</a>
        </li>
        @if (currentPage > 4) {
        <li class="page-item disabled">
          <a class="page-link">…</a>
        </li>
        }
        @for (page of getVisiblePages(); track page) {
        <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
          <a class="page-link">{{ page }}</a>
        </li>
        }
        @if (currentPage < pageCount - 3) {
        <li class="page-item disabled">
          <a class="page-link">…</a>
        </li>
        }
        @if (pageCount > 1) {
        <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
          <a class="page-link">{{ pageCount }}</a>
        </li>
        }
        <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
          <a class="page-link">&rsaquo;</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- Send Email Confirmation Modal -->
<ng-template #confirmEmailModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Send purchase order by email</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-0">The PO PDF will be emailed to the vendor's registered address. Continue?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btnprimary" (click)="confirmSendEmail(modal)">
      <i class="bi bi-envelope-paper"></i>Send email
    </button>
  </div>
</ng-template>

<!-- Recall PO Modal -->
<ng-template #recallModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Recall purchase order</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="mb-1">
      <label class="form-label">New expiry date for <span class="zf-mono text-primary">{{ selectedPoForRecall?.poNumber }}</span></label>
      <input type="date" class="form-control" [(ngModel)]="newExpiryDate" />
      <small class="text-muted d-block mt-2">The PO becomes active again until the new expiry date.</small>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btnprimary" (click)="extendExpiryDate(modal)" [disabled]="!newExpiryDate">
      Extend date
    </button>
  </div>
</ng-template>

<!-- Upload Result Modal -->
@if (showUploadResultModal && uploadResult) {
<div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true"
  style="background-color: rgba(18,20,26,0.5); z-index: 999999; position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          @if (uploadResult.createdPOs > 0 && uploadResult.errors.length === 0) {
          <i class="bi bi-check-circle-fill text-success me-2"></i>Upload complete
          } @else if (uploadResult.createdPOs > 0) {
          <i class="bi bi-exclamation-circle-fill text-warning me-2"></i>Partial success
          } @else {
          <i class="bi bi-x-circle-fill text-danger me-2"></i>Upload failed
          }
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeUploadResultModal()"></button>
      </div>
      <div class="modal-body">
        <div class="zf-tiles">
          <div class="zf-tile">
            <span class="zf-tile-label">Rows processed</span>
            <span class="zf-tile-value">{{ uploadResult.processed }}</span>
          </div>
          <div class="zf-tile">
            <span class="zf-tile-label">POs created</span>
            <span class="zf-tile-value text-success">{{ uploadResult.createdPOs }}</span>
          </div>
          <div class="zf-tile">
            <span class="zf-tile-label">Items added</span>
            <span class="zf-tile-value">{{ uploadResult.createdItems }}</span>
          </div>
          <div class="zf-tile">
            <span class="zf-tile-label">Errors</span>
            <span class="zf-tile-value" [class.text-danger]="uploadResult.errors.length > 0">{{ uploadResult.errors.length }}</span>
          </div>
        </div>

        @if (uploadResult.errors.length > 0) {
        <p class="fw-semibold text-danger mb-2">
          <i class="bi bi-exclamation-triangle-fill me-1"></i>Row errors
        </p>
        <div style="max-height: 200px; overflow-y: auto;">
          <ul class="list-unstyled mb-0">
            @for (err of uploadResult.errors; track $index) {
            <li class="text-danger small mb-1">
              <strong class="zf-mono">Row {{ err.row }}:</strong> {{ err.error }}
            </li>
            }
          </ul>
        </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnprimary" (click)="closeUploadResultModal()">OK</button>
      </div>
    </div>
  </div>
</div>
}
